import { EVENT_DELAY } from '@src/config/constants'
import { initializeSnapchatPixel } from '@src/quince-site-common/src/trackers/SnapchatInitializer'
import { initializeScript } from '@src/telemetry/integrations/provider-utils/initialize-script'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { TelemetryIntegration } from '@src/telemetry/telemetry-events.types'
import { executeFireAndForgotTask } from '@src/utils/fire-and-forgot-task'

import { TELEMETRY_DOMAINS } from '../telemetry-domains.constants'

export const SnapchatPixel: TelemetryIntegration = {
  config: {
    enabled: true,
    eventIdealTimeout: 1000,
    domain: TELEMETRY_DOMAINS.SNAPCHAT_PIXEL,
  },

  initialize: async () => {
    if (window.snaptr) return
    window.snaptr = function (...args) {
      const a = window.snaptr
      if (a) {
        if (a.handleRequest) {
          a.handleRequest(...args)
        } else {
          if (!a.queue) {
            a.queue = []
          }
          a.queue.push(args)
        }
      }
    }
    window.snaptr.queue = []

    await initializeScript({
      key: 'snapchat-pixel',
      domain: TELEMETRY_DOMAINS.SNAPCHAT_PIXEL,
      path: '/scevent.min.js',
      injectAt: 'beforeFirstScript',
      onLoad: initializeSnapchatPixel,
    })
  },

  events: {
    [TELEMETRY_EVENT_NAMES.PAGE_VIEW]: () => {
      executeFireAndForgotTask(() => {
        if (window.snaptr) window.snaptr('track', 'PAGE_VIEW')
      }, EVENT_DELAY)
    },

    [TELEMETRY_EVENT_NAMES.ADD_TO_CART]: properties => {
      executeFireAndForgotTask(() => {
        if (window.snaptr)
          window.snaptr('track', 'ADD_CART', {
            item_category: properties.productId,
            item_ids: [properties.variantId],
            item_type: 'product_group',
            price: formatRevenue(properties.price),
            currency: 'USD',
            number_items: properties.quantity || 1,
            description:
              properties.productTitle && properties.variantTitle
                ? properties.productTitle + ' - ' + properties.variantTitle
                : '',
          })
      }, EVENT_DELAY)
    },

    [TELEMETRY_EVENT_NAMES.PRODUCT_VIEW]: properties => {
      executeFireAndForgotTask(() => {
        if (window.snaptr)
          window.snaptr('track', 'VIEW_CONTENT', {
            item_category: properties.productId,
            item_ids: [properties.variantId],
            item_type: 'product_group',
            price: formatRevenue(properties.price),
            currency: 'USD',
            description:
              properties.productTitle && properties.variantTitle
                ? properties.productTitle + ' - ' + properties.variantTitle
                : '',
          })
      }, EVENT_DELAY)
    },

    [TELEMETRY_EVENT_NAMES.SEARCH]: properties => {
      executeFireAndForgotTask(() => {
        if (window.snaptr)
          window.snaptr('track', 'SEARCH', {
            search_string: properties.searchQuery,
          })
      }, EVENT_DELAY)
    },
  },
}

export const formatRevenue = (price?: string) => {
  if (price != null) {
    return price
  }
  return 0
}
